import React,{useEffect} from 'react'
import '../CSS/About.css'
import pic from "../Image/pic.jpg"
import hack from "../Image/hack.png"
import codechef from "../Image/cc.jpg"
import leetcode from "../Image/leetcode.png"
import gfg from "../Image/gfg.png"
import Aos from "aos"
import "aos/dist/aos.css"


const About = () => {

    useEffect(() => {
        Aos.init({duration:2000});
     }, []);
         

    return (
        <>
        
        <div className="backAbout">
            <div className="containerAbout">
                    <div className="col-10 mx-auto">
                        <div data-aos="fade-down" className="headerAbout">
                        <h1>About Me</h1>
                        </div>
                        <div className="mid">
                            <div className="col-md-6 me-auto imgdiv" data-aos="fade-right">
                                <img src={pic} className="img1" alt="profile pic..."/>
                            </div>
                            <div className="col-md-6 text ml-auto" data-aos="fade-left">
                            Hii,I am <span class='changeColor'></span>Suprodip Kundu,a web developer,coder,a newbie++ of this world of Competitive Programming.Currently a Final year Computer Science undergrad of Netaji Subhash Engineering College.<br/>
                            Always ready learn to new techstuff,if you have any info regarding weird and new technology knock me out in my LinkedIn.
                             
                            </div>
                        </div>  
                        <div className="mid1"> 
                            <h3> Join Me &nbsp;&bull;&nbsp; Lets Code</h3>
                            <a href="https://leetcode.com/provider/" target="blank"> <img src={leetcode} className="img2" alt="Leetcode..," data-aos="fade-up" data-aos-delay="500"/></a>
                            <a href="https://www.hackerrank.com/supro718" target="blank"> <img src={hack} className="img2" alt="Hackerrank..," data-aos="fade-up" data-aos-delay="500"/></a>
                            <a href="https://www.codechef.com/users/provider" target="blank"><img src={codechef} className="img2" alt="Codechef..." data-aos="fade-up" data-aos-delay="600"/></a> 
                            <a href="https://auth.geeksforgeeks.org/user/provider/practice/" target="blank"> <img src={gfg} className="img2" alt="Geeks For Geeks..." data-aos="fade-up" data-aos-delay="700"/></a>
                        </div>
                            
                
            </div>  
        
        </div>
        </div> 
        </>
        
    )
}

export default About

